"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeClient = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const __1 = require("..");
const types_1 = require("../types");
const lodash_1 = require("lodash");
const types_2 = require("../types");
class TradeClient {
    constructor(ctx, publicKey, data, pda, configid) {
        this.ctx = ctx;
        this.data = data;
        this.publicKey = publicKey;
        this.pda = pda;
        this.configId = configid;
    }
    static getTrade(ctx, configId, marketId, tradeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId, marketId);
            const tradePublickey = pda.getTradePDA(tradeId).key;
            const tradeAccount = (yield ctx.program.account.trade.fetch(tradePublickey));
            if (!tradeAccount) {
                throw new Error(`Trade ${tradeId} not found`);
            }
            return new TradeClient(ctx, tradePublickey, tradeAccount, pda, configId);
        });
    }
    getEvidenceAccount(ctx, user) {
        return __awaiter(this, void 0, void 0, function* () {
            const evidencePubkey = this.pda.getEvidencePDA(user, this.publicKey).key;
            const evidenceAccountData = (yield ctx.program.account.evidenceAccount.fetch(evidencePubkey));
            if (!evidenceAccountData) {
                throw new Error(`evidenceAccountData not found`);
            }
            return evidenceAccountData;
        });
    }
    release() {
        return __awaiter(this, void 0, void 0, function* () {
            const { sellerAuthority, buyerAuthority, tokenMint } = this.data;
            const marketTokenAccount = this.pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeAccount = this.pda.getMarketNativeVaultPDA(tokenMint).key;
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, sellerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, sellerAuthority), { address: sellerTokenAccount } = _a, createSellerTokenAccountInstruction = __rest(_a, ["address"]);
            const _b = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, buyerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, sellerAuthority), { address: buyerTokenAccount } = _b, createBuyerTokenAccountInstruction = __rest(_b, ["address"]);
            let taker;
            if ((0, lodash_1.isEqual)(this.data.side, types_1.TradeSide.Sell)) {
                taker = this.data.buyerAuthority;
            }
            else {
                taker = this.data.sellerAuthority;
            }
            let takerKycPubkey = this.pda.getKycCertPDA(taker, tokenMint).key;
            const tx = (yield this.ctx.ixs.releaseIx({
                marketAccount: this.data.marketAccount,
                marketTokenVault: marketTokenAccount,
                marketNativeVault: marketNativeAccount,
                kycCert: takerKycPubkey,
                offerAccount: this.pda.getOfferPDA(this.data.offerId).key,
                tradeAccount: this.publicKey,
                seller: sellerAuthority,
                buyer: buyerAuthority,
                sellerTokenAccount,
                buyerTokenAccount,
            }))
                .toTx()
                .prependInstructions([
                createSellerTokenAccountInstruction,
                createBuyerTokenAccountInstruction,
            ]);
            return tx;
        });
    }
    callArbitrator(caller) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = (yield this.ctx.ixs.callArbitrator({
                marketAccount: this.data.marketAccount,
                trade: this.publicKey,
                caller: caller,
            })).toTx();
            return tx;
        });
    }
    resolveDispute(arbitrator, disputeAction, compensationAction) {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenMint = this.data.tokenMint;
            const marketTokenAccount = this.pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeAccount = this.pda.getMarketNativeVaultPDA(tokenMint).key;
            // Get or create corressponding token accounts of parties if needed
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, arbitrator, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: arbitratorTokenAccount } = _a, createArbitratorTokenAccountInstruction = __rest(_a, ["address"]);
            const _b = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, this.data.sellerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: sellerTokenAccount } = _b, createSellerTokenAccountInstruction = __rest(_b, ["address"]);
            const _c = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, this.data.buyerAuthority, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: buyerTokenAccount } = _c, createBuyerTokenAccountInstruction = __rest(_c, ["address"]);
            const marketStateData = (yield this.ctx.program.account.marketState.fetch(this.data.marketAccount));
            const _d = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, marketStateData.treasuryPubkey, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, arbitrator), { address: treasuryTokenAccount } = _d, createTreasuryTokenAccountInstruction = __rest(_d, ["address"]);
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(disputeAction, types_2.DisputeAction.Cancel)) {
                let buyerKycCert = this.pda.getKycCertPDA(this.data.buyerAuthority, tokenMint);
                remainingAccounts = (0, __1.getRemaningAccounts)([buyerKycCert.key]);
            }
            let taker;
            if ((0, lodash_1.isEqual)(this.data.side, types_1.TradeSide.Sell)) {
                taker = this.data.buyerAuthority;
            }
            else {
                taker = this.data.sellerAuthority;
            }
            let takerKycPubkey = this.pda.getKycCertPDA(taker, tokenMint).key;
            const tx = (yield this.ctx.ixs.resolveDispute({
                marketNativeVault: marketNativeAccount,
                marketTokenVault: marketTokenAccount,
                disputeAction,
                compensationAction,
                marketAccount: this.data.marketAccount,
                kycCert: takerKycPubkey,
                offerAccount: this.pda.getOfferPDA(this.data.offerId).key,
                tradeAccount: this.publicKey,
                treasuryAuthority: marketStateData.treasuryPubkey,
                arbitratorAuthority: arbitrator,
                treasuryTokenAccount: treasuryTokenAccount,
                arbitartorCert: this.pda.getArbitratorCertPDA(arbitrator, tokenMint).key,
                arbitratorTokenAccount: arbitratorTokenAccount,
                seller: this.data.sellerAuthority,
                sellerTokenAccount: sellerTokenAccount,
                buyer: this.data.buyerAuthority,
                buyerTokenAccount: buyerTokenAccount,
                remainingAccounts,
            }))
                .toTx()
                .prependInstructions([
                createArbitratorTokenAccountInstruction,
                createBuyerTokenAccountInstruction,
                createSellerTokenAccountInstruction,
                createTreasuryTokenAccountInstruction,
            ]);
            return tx;
        });
    }
    cancelTrade(taker) {
        return __awaiter(this, void 0, void 0, function* () {
            const { marketAccount, tokenMint } = this.data;
            const marketTokenAccount = this.pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeAccount = this.pda.getMarketNativeVaultPDA(tokenMint).key;
            let marketStateData = (yield this.ctx.program.account.marketState.fetch(marketAccount));
            if (!marketStateData) {
                throw new Error(`market account: ${marketAccount} not found`);
            }
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, marketStateData.treasuryPubkey, this.data.tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, taker), { address: treasuryTokenAccount } = _a, createTreasuryTokenAccountInstruction = __rest(_a, ["address"]);
            // Get or create joiner token acccount
            const _b = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, taker, tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, taker), { address: takerTokenAccount } = _b, createTakerTokenAccountInstruction = __rest(_b, ["address"]);
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(this.data.side, types_1.TradeSide.Sell)) {
                let buyerKycCert = this.pda.getKycCertPDA(this.data.buyerAuthority, tokenMint);
                remainingAccounts = (0, __1.getRemaningAccounts)([buyerKycCert.key]);
            }
            let takerKycPubkey = this.pda.getKycCertPDA(taker, tokenMint).key;
            const tx = (yield this.ctx.ixs.cancelTradeIx({
                marketAccount: marketAccount,
                marketTokenVault: marketTokenAccount,
                marketNativeVault: marketNativeAccount,
                kycCert: takerKycPubkey,
                offerAccount: this.pda.getOfferPDA(this.data.offerId).key,
                tradeAccount: this.publicKey,
                treasuryAuthority: marketStateData.treasuryPubkey,
                treasuryTokenAccount: treasuryTokenAccount,
                taker: taker,
                takerTokenAccount: takerTokenAccount,
                remainingAccounts,
            }))
                .toTx()
                .prependInstructions([
                createTreasuryTokenAccountInstruction,
                createTakerTokenAccountInstruction,
            ]);
            return tx;
        });
    }
    savePaymentEvidence(buyer, sellerData, arbitratorData, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tokenMint } = this.data;
            const tx = (yield this.ctx.ixs.savePaymentEvidence({
                marketAccount: this.data.marketAccount,
                marketNativeVault: this.pda.getMarketNativeVaultPDA(tokenMint).key,
                evidencePDA: this.pda.getEvidencePDA(buyer, this.publicKey),
                sellerData: sellerData,
                arbitratordata: arbitratorData,
                nonce: nonce,
                tradeAccount: this.publicKey,
                user: buyer,
            })).toTx();
            return tx;
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const tradeAccount = (yield this.ctx.program.account.trade.fetch(this.publicKey));
            this.data = tradeAccount;
            return this;
        });
    }
}
exports.TradeClient = TradeClient;
